import React, { useState } from 'react';
import TopBar from './TopBar';
import SideMenu from './SideMenu';
import EstimateTransfer from '../pages/EstimateTransfer';
import Settings from '../pages/Settings';
import './AdminLayout.css';

function AdminLayout() {
  const [activeMenu, setActiveMenu] = useState('estimate-transfer');
  const [isMenuOpen, setIsMenuOpen] = useState(true);

  const renderContent = () => {
    switch (activeMenu) {
      case 'estimate-transfer':
        return <EstimateTransfer />;
      case 'settings':
        return <Settings />;
      default:
        return <EstimateTransfer />;
    }
  };

  return (
    <div className={`admin-layout${isMenuOpen ? ' menu-open' : ''}`}>
      <TopBar onMenuToggle={() => setIsMenuOpen((open) => !open)} />
      <SideMenu
        activeMenu={activeMenu}
        onMenuChange={setActiveMenu}
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
      />
      <main className={`main-content ${isMenuOpen ? 'menu-open' : ''}`}>
        {renderContent()}
      </main>
    </div>
  );
}

export default AdminLayout;
